import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authSlice from "features/auth/slice";
import contractSlice from "features/contracts/slice";

const rootReducer = combineReducers({
  [authSlice.name]: authSlice.reducer,
  [contractSlice.name]: contractSlice.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
